import { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { CalendarIcon } from '@/shared/assets'

import './dateRangePicker.scss'

interface DateRangePickerProps {
    startDate: string
    endDate: string
    onFromDateChange: (val: string) => void
    onToDateChange: (val: string) => void
    placeholder?: string
}

export const DateRangePicker = ({
    startDate,
    endDate,
    onFromDateChange,
    onToDateChange,
    placeholder = 'Выберите диапазон дат',
}: DateRangePickerProps) => {
    const parseDate = (dateString: string) => {
        const date = new Date(dateString)
        return isNaN(date.getTime()) ? undefined : date
    }

    const [localStartDate, setLocalStartDate] = useState<Date | undefined>(
        parseDate(startDate)
    )
    const [localEndDate, setLocalEndDate] = useState<Date | undefined>(
        parseDate(endDate)
    )

    useEffect(() => {
        setLocalStartDate(parseDate(startDate))
        setLocalEndDate(parseDate(endDate))
    }, [startDate, endDate])

    const formatDate = (date: Date): string => {
        return date.toISOString().split('T')[0]
    }

    // const handleFromDateChange = (date: Date | null) => {
    //     setLocalStartDate(date)
    //     if (date) {
    //         onFromDateChange(formatDate(date))
    //     }
    // }
    //
    // const handleToDateChange = (date: Date | null) => {
    //     setLocalEndDate(date)
    //     if (date) {
    //         onToDateChange(formatDate(date))
    //     }
    // }

    const handleDateRangeChange = (dates: [Date | null, Date | null]) => {
        const [start, end] = dates
        setLocalStartDate(start || undefined)
        setLocalEndDate(end || undefined)
        if (start) {
            onFromDateChange(formatDate(start))
        }
        if (end) {
            onToDateChange(formatDate(end))
        }
    }

    return (
        <section className="date-range-picker">
            <img
                src={CalendarIcon}
                alt="Calendar"
                className="date-picker-icon"
            />
            {/* <div className="date-range-picker__container"> */}
            {/*     <DatePicker */}
            {/*         selected={localStartDate} */}
            {/*         onChange={handleFromDateChange} */}
            {/*         dateFormat="dd.MM.yyyy" */}
            {/*         placeholderText="12.08.2024" */}
            {/*         className="date-input" */}
            {/*     /> */}
            {/* </div> */}
            {/* - */}
            {/* <div className="date-range-picker__container"> */}
            {/*     <DatePicker */}
            {/*         selected={localEndDate} */}
            {/*         onChange={handleToDateChange} */}
            {/*         dateFormat="dd.MM.yyyy" */}
            {/*         placeholderText="12.10.2024" */}
            {/*         className="date-input" */}
            {/*     /> */}
            {/* </div> */}
            <DatePicker
                selected={localStartDate}
                onChange={handleDateRangeChange}
                startDate={localStartDate}
                endDate={localEndDate}
                selectsRange
                dateFormat="dd.MM.yyyy"
                placeholderText={placeholder}
                className="date-input"
            />
        </section>
    )
}
